import React from 'react'
import './catering.scss'
import AutoMenu from '../../react/AutoMenu'
import {Link} from 'react-router-dom'
export default function () {
  return(

    <div className="sub-page">
      <h1 className="header-text">
        Taron Bakery Catering


      </h1>


      <div className="content">

        {/* catering form */}

       
      </div>
    </div>
     )
}
